/* eslint-disable max-lines */

import LoadingIndicator from 'components/LoadingIndicator';
import LoadingOverlay from 'react-loading-overlay-ts';

import EmptyTableState from 'components/EmptyTableState';
import ListFooter from 'components/ListFooter';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  getCustomerContracts,
  getCustomerContractsLoading,
  getCustomerContractsTotalCount,
} from 'selectors/customerContracts';
import CustomerContractListItem from './CustomerContractListItem';

const CustomerContractsList: React.FC = () => {
  const contracts = useSelector(getCustomerContracts);
  const loading = useSelector(getCustomerContractsLoading);

  const isEmpty = contracts.length === 0;

  return (
    <div className="table-wrapper__new no-scrollbar overflow-auto">
      <LoadingOverlay
        active={loading}
        spinner={<LoadingIndicator size="10" />}
        className="relative w-full h-full"
        fadeSpeed={0}
        styles={{
          content: (base) => ({
            ...base,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }),
          wrapper: () => ({}),
          spinner: () => ({}),
          overlay: (base) => ({
            ...base,
            zIndex: 10,
          }),
        }}
      >
        <table className="table-wrapper__table table-wrapper_table--fixed">
          <thead className="sticky top-0 z-10">
            <tr className="table-wrapper__header-tr h-10">
              <th className="table-wrapper__new-th table-wrapper__th--w-20 pl-6">
                Service of work
              </th>
              <th className="table-wrapper__new-th table-wrapper__th--w-8 p-0">Insight</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-8 p-0">Prevent</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-16 p-0">User List</th>
              <th className="table-wrapper__new-th table-wrapper__th--w-20 p-0">Contract</th>
              <th className="table-wrapper__new-th p-0">Notes</th>
              <th aria-hidden className="table-wrapper__new-th table-wrapper__th--w-6 p-0" />
            </tr>
          </thead>
          <tbody className="table-wrapper__tbody">
            {!loading && isEmpty ? (
              <EmptyTableState message="There are no statements to display" colCount="7" />
            ) : (
              contracts.map((contract) => (
                <CustomerContractListItem key={contract.uuid} contract={contract} />
              ))
            )}
          </tbody>
        </table>
        <div className="border-t border-gray-200 sticky bottom-0 z-10 bg-white">
          <ListFooter
            resourceStateName={resourceQueryParamName.customer_contracts}
            resourceName=""
            getResourceList={getCustomerContracts}
            getResourceTotalCount={getCustomerContractsTotalCount}
            getResourceLoading={getCustomerContractsLoading}
          />
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default CustomerContractsList;
